var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"online-content"},[_c('div',{staticClass:"online-myCenter"},[_c('sideBar'),(!_vm.$route.meta.keepAlive)?[_c('router-view')]:[_c('router-view')]],2)])}
var staticRenderFns = []

export { render, staticRenderFns }